import { clsx } from 'clsx/lite';
import { forwardRef } from 'react';
import styles from './TableRow.module.css';
import type { TableRowItem } from './types';

interface TableRowProps {
  row?: TableRowItem;
}

const TableRow = forwardRef<any, TableRowProps>(({ row }, ref) => {
  if (!row?.cells) {
    return null;
  }

  return (
    <tr className={clsx(styles.row, row.className)} ref={ref}>
      {row.cells.map((cell) => (
        <td
          key={cell.key}
          colSpan={cell.colSpan}
          className={clsx(styles.cell, cell.className)}
          ref={cell.ref}
        >
          {cell.children}
        </td>
      ))}
    </tr>
  );
});

export default TableRow;
